<template>
    <div class="cst-survey-header" :style="{ backgroundImage: `url('${image}')` }">
        <div class="cst-survey-logo" :style="logoBoxLayout">
            <img :src="logo" />
        </div>    
        <!-- <app-lng-switch></app-lng-switch> -->
        <!--  <app-header-exit-link></app-header-exit-link> -->
    </div>
</template>

<script>
    import AppLngSwitch from './AppLngSwitch'
    import { extractRGBfromStr, generateRGBAStr } from '../utils.js'
    export default {
      props: [ 'logo', 'image' ],
      computed: {
        logoBoxLayout: function () {
          var cssValues = {}
          if (this.$store.state.hotelData.layout) {
            var layout = this.$store.state.hotelData.layout.logo
            if (!layout['visible']) {
              cssValues['display'] = 'none'
            }
            if (!layout['padded-box']) {
              cssValues['padding'] = 0
            }
            if (layout.transparency) {
              cssValues['background-color'] = generateRGBAStr(...extractRGBfromStr(layout['background-color']), 0.8)
            } else {
              cssValues['background-color'] = layout['background-color']
            }
          }
          return cssValues
        }
      },
      components: {
        AppLngSwitch
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';
    
    .cst-survey-logo {
        background-color: rgba(255, 255, 255, 0.8);
        display: inline-block;
        padding: 15px;
        margin: 15px;
        margin-top: 0;
        box-shadow: 0 0.08em 0.16em 0 rgba(0, 0, 0, 0.2), 0 0.12em 0.4em 0 rgba(0, 0, 0, 0.19);
    }
    .cst-survey-header {
        height: 18vh;
        background-size: cover;
        min-height: 9em;
        background-position: center;
    }
    .cst-survey-logo img {
        max-height: 100px;
        margin: 0 auto;
    }
    img {
        display: block;
    }

    @media (max-width: 500px) {
      .cst-survey-header {
        min-height: 7em;
      }
    }

</style>


// WEBPACK FOOTER //
// src/components/AppHeader.vue